import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ConfirmDirective} from "../../../../../directives/confirm/confirm.directive";
import {PaginatorComponent} from "../../../../layout/paginator/paginator.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TableSorterHeaderDirective} from "../../../../../directives/table-sorter/table-sorter-header.directive";
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {RouterLink} from '@angular/router';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {RedirectRule} from '../../../../../models/redirect-rule/redirect-rule';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {RedirectRuleService} from '../../../../../services/redirect-rule/redirect-rule.service';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {NgOptimizedImage} from '@angular/common';
import {LangService} from '../../../../../services/language/lang.service';
import {ListFilters} from '../../../../../tools/list-filters/list-filters';
import {ListFilterService} from '../../../../../services/list-filter/list-filter.service';
import {DropdownSelectComponent} from '../../../../layout/dropdown-select/dropdown-select.component';
import {
  DropdownSelectOptionComponent
} from '../../../../layout/dropdown-select-option/dropdown-select-option.component';
import {debounceTime, forkJoin, Subject} from 'rxjs';
import {AvailableDomain} from '../../../../../models/cms/available-domain';
import {AvailableDomainService} from '../../../../../services/cms/available-domain.service';
import {Product} from '../../../../../models/product';
import {ProductService} from '../../../../../services/product/product.service';
import {Language} from '../../../../../models/language';

@Component({
  imports: [
    ConfirmDirective,
    PaginatorComponent,
    ReactiveFormsModule,
    TableSorterHeaderDirective,
    IsGrantedDirective,
    RouterLink,
    TableSorterDirective,
    NgOptimizedImage,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    FormsModule
  ],
  selector: 'app-redirect-rule-list',
  styleUrl: './redirect-rule-list.component.scss',
  templateUrl: './redirect-rule-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
@IsGranted(['REDIRECT_RULE_VIEW'])
@MetaTitle('Redirect links list')
export class RedirectRuleListComponent implements OnInit {
  redirectRules: RedirectRule[] = [];
  availableDomains: AvailableDomain[] = [];
  products: Product[] = [];
  languages: Language[] = [];

  filters: ListFilters;
  nameChange$ = new Subject<void>();

  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private redirectRuleService: RedirectRuleService,
    private availableDomainService: AvailableDomainService,
    private productService: ProductService,
    private listFilterService: ListFilterService,
    protected langService: LangService,
  ) {
    this.filters = listFilterService.createFilters({
      name: 'string',
      domainId: 'number[]',
      productId: 'number[]',
      lang: 'string[]',
      identifier: 'string',
    }, this.paginator, this.tableSorter);
  }

  ngOnInit(): void {
    forkJoin([
      this.availableDomainService.findAll({sort: 'domain'}),
      this.productService.findAll({sort: 'name'}),
      this.langService.getLanguages(),
    ]).subscribe(([availableDomains, products, languages]) => {
      this.availableDomains = availableDomains;
      this.products = products;
      this.languages = languages;
    });

    this.nameChange$.pipe(debounceTime(1000)).subscribe(() => this.filters.onFilterChange());
    this.filters.init(() => this.fetchAll());
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.redirectRuleService.findAll(this.filters.toParams(), this.paginator, this.tableSorter).subscribe((redirectRules: RedirectRule[]) => {
      this.redirectRules = redirectRules;
      this.loader.stopLoading();
    });
  }

  delete(redirectRule: RedirectRule): void {
    if (redirectRule.id) {
      this.loader.startLoading();
      this.redirectRuleService.delete(redirectRule.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Redirect rule link has been deleted');
        this.fetchAll();
      });
    }
  }

  onNameChange(): void {
    this.nameChange$.next();
  }
}
